import React, { useEffect, useRef, useState } from "react";
import "../App.css";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import Modal from "./Modal";
// JSON Data
const pageData = {
  hero: {
    videoSrc:
      "https://paintfactory.metaluxe.com.au/theme/paintfactory/4k-background.mp4",
    introText:
      "AN EXCLUSIVE CITY FRAME OPPORTUNITY UNPARALLELED, IRREPLACEABLE",
    watchFilmText: "WATCH THE FILM",
    playButtonIcon: "/icons/playbtn.svg",
    scrollText: "SCROLL",
  },
  banner: {
    registerInterestText: "REGISTER INTEREST NOW",
  },
  sections: [
    {
      type: "tags",
      content: `1 bedroom residences from 50m<sup>2</sup><br />
                2 bedroom residences from 70m<sup>2</sup><br />
                3 bedroom residences from 100m<sup>2</sup><br />
                Sky Homes from 125m<sup>2</sup>`,
    },
    {
      type: "text",
      content: `Anchoring Yeronga’s 115 Hyde Street, the Paint Factory transforms
                a storied industrial site into a vibrant arts-led precinct.
                Galleries, studios and performance spaces flow into boutique
                restaurants and cafés, while architect-designed residences rise
                above landscaped public courtyards. Heritage character and
                contemporary comfort combine to create a truly one-of-a-kind urban
                village—an opportunity unlikely to be repeated.`,
    },
    // {
    //   type: "image",
    //   src: "/images/111.png",
    //   caption: "The Paint Factory",
    // },
    {
      type: "video",
      src: "https://paintfactory.metaluxe.com.au/theme/paintfactory/the-paintfactory.mp4",
      caption: "THE PAINT FACTORY",
    },
    {
      type: "cta",
      title: "RESIDENCES",
      description: `Featuring meticulously designed, light-filled residences, this
                    landmark development redefines luxury waterfront living.`,
      buttonText: "DISCOVER MORE",
      link: "/residences",
    },
    {
      type: "gallery",
      items: [
        {
          src: "/images/102.jpeg",
          caption: "ARRIVAL CONSERVATORY, SKY HOMES — Artist’s impression",
        },
        {
          src: "/images/residences city-scape.png",
          caption: "RESIDENCES CITY SCAPE  — Artist’s impression",
        },
      ],
    },
    {
      type: "cta",
      title: "RELAX YOU ARE HOME",
      description: `The Loft Residences at the Paint Factory are uncompromising homes
                    for those who expect the exceptional. Spanning 250-square-metre
                    floorplates, each light-filled loft pairs raw industrial character
                    with refined finishes, opening onto sweeping views of the Brisbane
                    River corridor and the city skyline.`,
      buttonText: "DISCOVER MORE",
    },
    // {
    //   type: "image",
    //   src: "/images/108.png",
    //   caption: "SEASCAPE SKY HOMES MASTER SUITE",
    // },
    {
      type: "video",
      src: "https://paintfactory.metaluxe.com.au/theme/paintfactory/relax-you-are-home.mp4",
      caption: "RELAX YOU ARE HOME",
    },
    {
      type: "cta",
      title: "Paint Factory Precinct",
      description: `This exclusive lifestyle stretches well beyond your loft’s
                    industrial-chic interiors, unlocking private galleries, rooftop
                    gardens, wellness studios and chef-run eateries—all overseen by a
                    resident concierge team.`,
      buttonText: "DISCOVER MORE",
      link: "#",
    },
    // {
    //   type: "image",
    //   src: "/images/104.png",
    //   caption: "LIFESTYLE",
    // },
    {
      type: "video",
      src: "https://paintfactory.metaluxe.com.au/theme/paintfactory/lifestyle.mp4",
      caption: "LIFESTYLE",
    },
    // {
    //   type: "cta",
    //   title: "Too Green?",
    //   description: `Can you be too green? Never. The Paint Factory in Yeronga proves
    //                 you can never overdo sustainability, weaving ecological living
    //                 into every brick and beam.`,
    //   buttonText: "DISCOVER MORE",
    //   link: "#",
    // },

    {
      type: "grid",
      items: [
        {
          title: "HOTEL",
          src: "/images/hotel.png",
          description: `The Paint Factory sets a new benchmark for sustainable,
                        art-driven living on Brisbane’s river...`,
          linkText: "DISCOVER MORE",
        },
        {
          title: "RESIDENCES",
          src: "/images/residence-view.jpg",
          description: `The Paint Factory’s industrial-chic lofts deliver uniquely
                        spacious homes, crafted for art-infused city living and
                        beyond.`,
          linkText: "DISCOVER MORE",
        },
        {
          title: "ARTS to LIFESTYLE",
          src: "/images/lifestyle.jpg",
          description: `The Paint Factory’s galleries and studios spark Brisbane’s
                        creative heart, delivering immersive spaces where art is
                        crafted, showcased and lived.`,
          linkText: "DISCOVER MORE",
        },
      ],
    },
  ],
};

// Template Code

const Home = () => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  useEffect(() => {
    const sections = document.querySelectorAll(".fade-in-section");
    const banners = document.querySelectorAll(".animate-slide-in-left");

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    banners.forEach((banner) => observer.observe(banner));
    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
      banners.forEach((banner) => observer.unobserve(banner));
    };
  }, []);

  const nextSectionRef = useRef(null);

  const scrollToNextSection = () => {
    nextSectionRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="font-sans">
      <main>
        <section id="hero" className="bg-gray-100">
          <div className="relative">
            <video autoPlay muted controls={false} loop>
              <source src={pageData.hero.videoSrc} type="video/mp4" />
            </video>
            <div className="intro">
              <h1>{pageData.hero.introText}</h1>
              <div
                className="flex-center mt-36 mb-6"
                onClick={() => setIsVideoOpen(true)}
              >
                <img
                  src={pageData.hero.playButtonIcon}
                  style={{ height: "25px" }}
                  className="mr-2"
                  alt="Play Button"
                />
                <p className="border-white border-b-2 intro_title">
                  {pageData.hero.watchFilmText}
                </p>
              </div>
            </div>
            <div className="scroll" onClick={scrollToNextSection}>
              <p className="text-white">{pageData.hero.scrollText}</p>
              <svg
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 9.81 30"
                className="arrow"
              >
                <path fill="none" stroke="#fff" d="M4.91 0v24.8"></path>
                <path fill="#fff" d="M4.91 30l4.9-5.27H0L4.91 30z"></path>
              </svg>
            </div>
          </div>
        </section>

        <div id="banner" ref={nextSectionRef}>
          <div className="animate-slide-in-left">
            <div className="banner_slide flex-center">
              <p className="text-p">{pageData.banner.registerInterestText}</p>
            </div>
          </div>
        </div>

        {pageData.sections.map((section, index) => {
          if (section.type === "tags") {
            return (
              <section key={index} className="my-16">
                <div
                  className="fade-in-section mx-8 text-p uppercase"
                  dangerouslySetInnerHTML={{ __html: section.content }}
                ></div>
              </section>
            );
          }
          if (section.type === "text") {
            return (
              <section class="my-28">
                <div class="fade-in-section section-entry show">
                  <p class="text-p-s">{section.content}</p>
                </div>
              </section>
            );
          } else if (section.type === "image") {
            return (
              <section key={index} className="my-16">
                <div className="fade-in-section">
                  <img
                    src={section.src}
                    className="mt-8 w-auto m-auto"
                    alt=""
                  />
                  <p className="text-p-m mt-2">{section.caption}</p>
                </div>
              </section>
            );
          } else if (section.type === "video") {
            return (
              <section key={index} className="my-16">
                <div className="fade-in-section">
                  <video
                    autoPlay
                    muted
                    controls={false}
                    loop
                    className="mt-8 w-auto m-auto"
                  >
                    <source src={section.src} type="video/mp4" />
                  </video>
                  <p className="text-p-m mt-2">{section.caption}</p>
                </div>
              </section>
            );
          } else if (section.type === "cta") {
            return (
              <section key={index} className="my-16">
                <div className="fade-in-section text-center px-8 py-14">
                  <h1 className="header text-4xl text-black tracking-widest">
                    {section.title}
                  </h1>
                  <p className="text-p-xxxs my-8 section-entry py-8">
                    {section.description}
                  </p>
                  {section.link && (
                    <Link to={section.link} reloadDocument>
                      <button className="btn">{section.buttonText}</button>
                    </Link>
                  )}
                </div>
              </section>
            );
          } else if (section.type === "gallery") {
            return (
              <section key={index} className="my-16">
                <div className="shell">
                  <div className="fade-in-section mt-16 m-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-24 md:gap-6 px-8">
                      {section.items.map((item, idx) => (
                        <div key={idx}>
                          <img
                            src={item.src}
                            className="h-full object-cover"
                            alt=""
                          />
                          <p className="text-p-m mt-3">{item.caption}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </section>
            );
          } else if (section.type === "grid") {
            return (
              <section key={index} className="my-44">
                <div className="shell">
                  <div className="fade-in-section">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      {section.items.map((item, idx) => (
                        <div key={idx} className="flex flex-col">
                          <div className="border-top">
                            <p className="title pt-8 pb-4">{item.title}</p>
                          </div>
                          <img src={item.src} className="my-5 " alt="" />
                          <p className="text-p-xs pt-2 pb-3 h-[95px]">
                            {item.description}
                          </p>
                          <a href="#" className="text-p-xs underline">
                            {item.linkText}
                          </a>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </section>
            );
          }
          return null;
        })}

        <Footer />
      </main>

      <Modal isOpen={isVideoOpen} setIsOpen={setIsVideoOpen}>
        <video
          autoPlay={true}
          playsInline={true}
          muted={false}
          controls={true}
          loop={true}
          className="w-full h-full object-cover"
        >
          <source
            src={`https://paintfactory.metaluxe.com.au/theme/paintfactory/hero-section.mp4`}
            type="video/mp4"
          />
        </video>
      </Modal>
    </div>
  );
};

export default Home;
